import { jsx } from 'react/jsx-runtime';
import '../../../../utils/index_orig/index.esm.js';
import '../../../../utils/theme/theme-provider/index.esm.js';
import { useLocalization } from '@shared-ui/localization-context';
import styles from '../../../../styles/uitk-egds-calendar.css';
import { EGDSDateNumberThemes, EGDSTypeSizes, EGDSTypeWeights } from '../../../types/index.esm.js';
import { classNames } from '../../../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
/**
 * This is where the description of Date Number will go.
 */
const EGDSDateNumber = props => {
  const {
    theme = 'default',
    size = 300,
    weight = 'regular',
    disabled = false,
    children
  } = props;
  const wrapperClassNames = getClassNameList('uitk-date-number', EGDSDateNumberThemes.get(theme), EGDSTypeSizes.get(size), EGDSTypeWeights.get(weight), {
    'is-disabled': disabled
  });
  const l10n = useLocalization();
  const ariaLabel = theme === 'today' ? l10n.formatText('calendar.today.a11yLabel') : null;
  return jsx("div", {
    className: wrapperClassNames,
    "aria-hidden": !ariaLabel,
    ...(ariaLabel && {
      'aria-label': ariaLabel
    }),
    children: children
  });
};
EGDSDateNumber.displayName = 'EGDSDateNumber';
export { EGDSDateNumber };